module.exports = __webpack_public_path__ + "static/img/sprite2310.35d6540.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/sprite2310.png
// module id = D79Y
// module chunks = 7